import type { DOMOutputSpec, Mark, MarkSpec } from 'prosemirror-model';

import type { RtSchemaType } from '../../../editor/types';
import { sanitizeUrl } from '../../../helpers/utils';
import { MarkName } from '../../../schema/marks';
import type { ProsemirrorAttrs } from '../../../schema/schema';

export interface LinkAttributes {
  href: string;
  target: '_blank';
  rel: 'noopener';
}

export class LinkMark implements MarkSpec {
  public static readonly markName = MarkName.Link;
  public static is(mark: Mark) {
    return mark.type.name === LinkMark.markName;
  }
  public attrs: ProsemirrorAttrs<LinkAttributes> = {
    href: {},
    rel: { default: 'noopener' },
    target: { default: '_blank' },
  };
  public inclusive = false;
  public parseDOM = [
    {
      tag: 'a[href]',
      getAttrs: (dom: HTMLElement) => {
        if (!!dom.querySelector('img')) {
          return false;
        }
        return {
          href: dom.getAttribute('href')!,
        };
      },
    },
  ];
  public toDOM(node: Mark): DOMOutputSpec {
    const { href, target, rel } = <LinkAttributes>node.attrs;
    return ['a', { href: sanitizeUrl(href), target, rel }, 0];
  }
}

export type LinkSchema = RtSchemaType<any, typeof LinkMark>;
